import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2/dist/sweetalert2.js';
import { AuthService } from '../auth.service';
import { DataService } from '../data/data.service';
import { OrganizationService } from '../organization.service';
import { RedirectService } from '../redirect.service';
import { ParentAccount } from '../data/parent-account';
import { AddParentAccountModalComponent } from '../add-parent-account-modal/add-parent-account-modal.component'
import { mergeMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;
  invalid = false;
  loggingIn = null;
  sessionExpired = false;
  parent: ParentAccount;
  isParentLogin: boolean;
  token: string;


  constructor(
    private authService: AuthService,
    private organizationService: OrganizationService,
    private redirectService: RedirectService,
    private dataService: DataService,
    protected route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.sessionExpired = params.expired == "1";
      this.token = params.token;
      this.logInWithToken();
    });
    this.route.url.subscribe(path => {
      if (path[1] && path[1].path.includes('parent')) {
        this.isParentLogin = true;
      }
    });
  }

  logIn(): void {
    if (this.username && this.password) {
      this.loggingIn = true;
      this.dataService.createAccountSession(this.username, this.password)
        .subscribe(session => {
          if (session != null) {
            this.authService.setSession(session);
            if (session.SessionType === 'Parent') {
              this.redirectService.redirectToParentAccount(session.ID);
            } else {
              this.dataService.getOrganizations()
                .subscribe(organizations => {
                  this.organizationService.setOrgs(organizations);
                  if (this.authService.isLoggedIn()) {
                    this.redirectService.redirect();
                  } else {
                    this.loggingIn = null;
                    this.invalid = true;
                  }
                });
            }
          } else {
            this.loggingIn = false;
            this.invalid = true;
          }
        })
    } else {
      swal.fire('Oops!', 'Email address and password are required.', 'error');
      this.loggingIn = null;
      this.invalid = true;
    }
  }

  logInWithToken(): void {
    if (this.token) {
      this.loggingIn = true;
      this.dataService.createAccountSessionWithToken(this.token)
        .subscribe(session => {
          if (session != null) {
            this.authService.setSession(session);
            if (session.SessionType === 'Parent') {
              this.redirectService.redirectToParentAccount(session.ID);
            } else {
              this.dataService.getOrganizations()
                .subscribe(organizations => {
                  this.organizationService.setOrgs(organizations);
                  if (this.authService.isLoggedIn()) {
                    this.redirectService.redirect();
                  } else {
                    this.loggingIn = null;
                    this.invalid = true;
                  }
                });
            }
          } else {
            this.loggingIn = false;
            this.invalid = true;
            document.location.href = 'https://clever.com/login';
          }
        })
    }
  }
}
